import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent implements OnInit {
    public isLoading: boolean = false;

    constructor(private readonly loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingService.isLoading().subscribe((isLoading) => {
            this.isLoading = isLoading;
        });
    }
}
